import { BudgetPhases } from 'business/constants';
import { translateBlockValue } from 'i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryUpdateContentT } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/types';
import { getAmountFieldForPhase } from 'routes/BudgetModule/shared/phases/helpers';
import {
    StyHeader,
    StyHighlightedText,
    StyPaper,
    StyColouredText,
} from './StyledComponents';

type Props = {
    content: HistoryUpdateContentT;
    user: { email: string } | null;
};

export const CommentUpdate: React.FC<Props> = ({ content, user }) => {
    const { t } = useTranslation();
    const { comment } = content;
    const userLabel = user?.email ?? t('common.unknown');

    return (
        <>
            <StyHeader>
                <StyHighlightedText>{userLabel}</StyHighlightedText>
                {t('budgetHistory.eventLabel')}
            </StyHeader>
            <StyPaper elevation={0} variant="outlined">
                <p>
                    <span>{t('budgetHistory.after')}</span>
                    <StyColouredText>{comment?.after}</StyColouredText>
                </p>
                <p>
                    <span>{t('budgetHistory.before')}</span>
                    <StyColouredText>{comment?.before}</StyColouredText>
                </p>
            </StyPaper>
        </>
    );
};

export const StatusUpdate: React.FC<Props> = ({ content, user }) => {
    const { t } = useTranslation();
    const { status } = content;
    const userLabel = user?.email ?? t('common.unknown');

    return (
        <StyHeader>
            <StyHighlightedText>{userLabel}</StyHighlightedText>
            {t('budgetHistory.eventStatus')}
            <StyHighlightedText>
                {translateBlockValue(String(status.before))}
            </StyHighlightedText>
            {t('budgetHistory.at')}
            <StyHighlightedText>
                {translateBlockValue(String(status.after))}
            </StyHighlightedText>
        </StyHeader>
    );
};

export const AmountUpdate: React.FC<Props & { phase: BudgetPhases }> = ({
    content,
    user,
    phase,
}) => {
    const { t } = useTranslation();
    const metric = getAmountFieldForPhase(phase);
    const { amount } = content;
    const userLabel = user?.email ?? t('common.unknown');

    return (
        <StyHeader>
            <StyHighlightedText>{userLabel}</StyHighlightedText>
            {t('budgetHistory.eventAmount')}
            {translateBlockValue(metric)}
            &nbsp;
            <StyHighlightedText>{amount?.before}</StyHighlightedText>
            &nbsp;€
            {t('budgetHistory.to')}
            <StyHighlightedText>{amount?.after}</StyHighlightedText>
            &nbsp;€
        </StyHeader>
    );
};
